module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_33.6a301328.jpg";